const notFoundPage = (WpTag) => `
  title
  subtitle
  button {
    text
    url {
      url
    }
  }
`;

module.exports.notFoundPage = notFoundPage;
